import React, { useState } from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
} from "@mui/material";

const COURSES = [
    { _id: "6954f663d72c13bdbdddf3a5", title: "Advance Mentorship" },
];

export default function GiveCourseAccessModal({ modalOpen, setModalOpen, selectedUser }) {
    const [videoCourseId, setVideoCourseId] = useState("");
    const [amount, setAmount] = useState(0);
    const [progress, setProgress] = useState(false);

    const handleSubmit = async () => {
        if (!videoCourseId) {
            alert("Please select a course");
            return;
        }

        setProgress(true);

        const res = await fetch("https://api.sovrenn.com/manual/investing-course-enroll", {
            method: "PATCH",
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                user_id: selectedUser?._id,
                video_course_id: videoCourseId,
                amount: Number(amount),
            }),
        }).then((r) => r.json());

        setProgress(false);

        if (res.success) {
            setAmount(0);
            setVideoCourseId("");
            setModalOpen(false);
            alert("Course access given successfully");
            return;
        }

        alert(res.message || "Something went wrong");
    };

    return (
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    p: 4,
                    bgcolor: "background.paper",
                    maxWidth: 400,
                    width: "90%",
                    borderRadius: 2,
                    boxShadow: 24,
                }}
            >
                <Typography variant="h5" gutterBottom>
                    {selectedUser?.first_name} {selectedUser?.last_name}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                    Email: {selectedUser?.email}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Phone: {selectedUser?.phone_number}
                </Typography>

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Select Course</InputLabel>
                    <Select
                        value={videoCourseId}
                        onChange={(e) => setVideoCourseId(e.target.value)}
                        label="Select Course"
                    >
                        {COURSES.map((course) => (
                            <MenuItem key={course._id} value={course._id}>
                                {course.title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    fullWidth
                    type="number"
                    label="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    sx={{ mb: 3 }}
                />

                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={progress}
                    color="info"
                >
                    {progress ? "Processing..." : "Give Course Access"}
                </Button>
            </Box>
        </Modal>
    );
}
